import { connect, useDispatch } from "react-redux";
import { IWidgets } from "../../../../models/master/widgets";
import { IStudentScholarship } from "../../../../models/student/studentAccountsDetails";
import { useEffect } from "react";
import { limit, pageBlockId } from "../../../../constants/pageBlocks";
import { getWidgets } from "../../../../action/masters/widgetActionCreator";
import { setWidgets } from "../../../../store/slices/master/widgetSlice";
import { baseURL } from "../../../../constants/commonConstants";
import { apiConfig } from "../../../../constants/apiConfig";
import { getPageBlockData } from "../../../../common-functions/commonFunctions";

const StudentScholarship = (props: IStudentScholarship) => {
  const { scholarshipWidget, scholarship, snapShots } = props;
  const dispatch = useDispatch();

  const pageBlockData = getPageBlockData(snapShots, pageBlockId.scholarship);

  useEffect(() => {
    if (pageBlockData?.displayOrNot) {
      scholarshipWidget(pageBlockId.scholarship, limit.one);
    }
  }, [pageBlockData]);

  const studentScholarship = apiConfig.studentScholarshipBaseUrl;

  useEffect(() => {
    return () => {
      dispatch(setWidgets([]));
    };
  }, []);

  const handleRedirect = () => {
    window.open(studentScholarship, "_blank");
  };

  return (
    <>
      <div
        className={
          pageBlockData?.displayOrNot ? "card-wrap" : "card-wrap card-snapshot"
        }
        style={
          pageBlockData?.displayOrNot === false
            ? { backgroundImage: `url(${baseURL + pageBlockData.image})` }
            : {}
        }
      >
        <div className="">
          {scholarship
            ?.filter((scholarship: IWidgets) => scholarship.displayOrNot)
            .map((scholarship: IWidgets) => (
              <>
                <div
                  className="img w-100"
                  style={{ height: "150px", overflow: "hidden" }}
                >
                  <img src={baseURL + scholarship.image} alt="" />
                </div>
                <div className="desc w-100 mt-2">
                  <h2 className="para-hide-1 mb-2">{scholarship.name}</h2>
                  <span className="para-hide-2">{scholarship.description}</span>
                  <button
                    className="btn btn-primary m-auto mt-3 w-150"
                    onClick={handleRedirect}
                  >
                    More Details
                  </button>
                </div>
              </>
            ))}
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  scholarshipWidget: (pageBlockId?: number, noOfItems?: number) =>
    getWidgets(undefined, pageBlockId, undefined, noOfItems),
};

function mapStateToProps(state: any) {
  return {
    scholarship: state.widget.scholarshipWidget,
    snapShots: state.snapShot.snapShots,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(StudentScholarship);
